import type { ThemeTypings } from '@chakra-ui/react';
import type { Vendor_Questionnaire_Statuses_Enum } from '@main/graphql/types.generated';
import type { ParseKeys } from 'i18next';

/* Structural copy of the ComplyKit tone union; this lib carries data only
 * and stays free of UI dependencies. */
type StatusTone = 'neutral' | 'info' | 'success' | 'warning' | 'critical';

type QuestionnaireStatuses = {
  [key in Vendor_Questionnaire_Statuses_Enum]: {
    value: ParseKeys;
    /** Semantic tone for ComplyKit Status (badge-status-tag.md). */
    tone: StatusTone;
    /** Legacy Chakra scheme, kept for the PDF renderers still on StatusTag. */
    colorScheme: ThemeTypings['colorSchemes'];
  };
};

/* Created is a fact, not an alarm: the old yellow map was the drift, so it
 * collapses to neutral while expiring keeps its warning urgency. */
export const QUESTIONNAIRE_STATUSES: QuestionnaireStatuses = {
  created: {
    value: 'vendors.questionnaires.status.created',
    tone: 'neutral',
    colorScheme: 'yellow',
  },
  pending: { value: 'vendors.questionnaires.status.pending', tone: 'neutral', colorScheme: 'gray' },
  submitted: {
    value: 'vendors.questionnaires.status.submitted',
    tone: 'success',
    colorScheme: 'green',
  },
  expiring: {
    value: 'vendors.questionnaires.status.expiring',
    tone: 'warning',
    colorScheme: 'yellow',
  },
  overdue: { value: 'vendors.questionnaires.status.overdue', tone: 'critical', colorScheme: 'red' },
  revoked: { value: 'vendors.questionnaires.status.revoked', tone: 'critical', colorScheme: 'red' },
};
